import { render, staticRenderFns } from "./AreYouMarried.vue?vue&type=template&id=606a6863&scoped=true"
import script from "./AreYouMarried.vue?vue&type=script&lang=js"
export * from "./AreYouMarried.vue?vue&type=script&lang=js"
import style0 from "./AreYouMarried.vue?vue&type=style&index=0&id=606a6863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a6863",
  null
  
)

export default component.exports